import { AbstractControl, ValidatorFn } from '@angular/forms';

export function vuePostalCodeValidator(country: 'USA' | 'CAN'): ValidatorFn {
	return (control: AbstractControl) => {
		// ==== Regex Rules ======
		// Must be 5 numbers.
		const usaStandardPostalCode = /^([0-9]{5})$/;
		// ==== Regex Rules ======
		// Must be 9 numbers. The dash must be between the first 5 and last four numbers.
		const usaExtendedPostalCode = /^([0-9]{5})([-]{1})([0-9]{4})$/;
		// ==== Regex Rules ======
		// Must follow the following format: letter/number/letter/number/letter/number
		// The letters are case insensitive.
		const canPostalCode = /^([a-zA-Z]{1})([0-9]{1})([a-zA-Z]{1})([0-9]{1})([a-zA-Z]{1})([0-9]{1})$/;

		if (country === 'USA') {
			return !control.value ||
				usaStandardPostalCode.test(control.value) ||
				usaExtendedPostalCode.test(control.value)
				? null
				: { vueUsaPostalCode: true };
		} else {
			return !control.value || canPostalCode.test(control.value) ? null : { vueCanadaPostalCode: true };
		}
	};
}
